/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StockReceipt } from '../../models/stock-receipt';

export interface StockReceiptsControllerFindById$Params {
  id: string;
}

export function stockReceiptsControllerFindById(http: HttpClient, rootUrl: string, params: StockReceiptsControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<StockReceipt>> {
  const rb = new RequestBuilder(rootUrl, stockReceiptsControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StockReceipt>;
    })
  );
}

stockReceiptsControllerFindById.PATH = '/stock/receipts/{id}';
